<template>
  <b-card no-body>
    <b-card-body>
      <b-alert
        show
        variant="info"
        class="mb-0"
      >
        <div class="alert-body">
          Her sayfanın arama motorlarında görünen başlığını, açıklamasını ve anahtar kelimelerini buradan yönetebilirsiniz.
          Boş bırakılan alanlar sayfanın kendi içeriğinden otomatik üretilir. İngilizce / Almanca karşılıkları
          <b>Dil Çeviri</b> ekranından girilir.
        </div>
      </b-alert>
    </b-card-body>
    <b-table
      :fields="fields"
      :items="dataList"
      striped
      responsive
    >
      <template #cell(title)="data">
        <div class="font-weight-bold">
          {{ data.item.title }}
        </div>
        <small class="text-muted">{{ data.item.route }}</small>
      </template>
      <template #cell(meta_title)="data">
        <span v-if="data.item.meta_title">{{ data.item.meta_title }}</span>
        <span
          v-else
          class="text-muted"
        >Otomatik</span>
      </template>
      <template #cell(meta_desc)="data">
        <b-badge :variant="data.item.meta_desc ? 'light-success' : 'light-secondary'">
          {{ data.item.meta_desc ? 'Girildi' : 'Otomatik' }}
        </b-badge>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <b-button
            size="sm"
            variant="outline-primary"
            :to="$route.path + '/edit/' + data.item.id"
          >
            <FeatherIcon icon="EditIcon" />
            Güncelle
          </b-button>
        </div>
      </template>
    </b-table>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BAlert, BTable, BButton, BBadge,
} from 'bootstrap-vue'

const tableName = 'components'
export default {
  name: 'Index',
  components: {
    BCard,
    BCardBody,
    BAlert,
    BTable,
    BButton,
    BBadge,
  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'SAYFA',
        },
        {
          key: 'meta_title',
          label: 'META BAŞLIK',
        },
        {
          key: 'meta_desc',
          label: 'AÇIKLAMA',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          `${tableName}.route AS route`,
          `${tableName}.meta_title AS meta_title`,
          `${tableName}.meta_desc AS meta_desc`,
        ],
        where: {
          'components.seo': 1,
        },
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['components/dataList']
    },
    saveData() {
      return this.$store.getters['components/dataSaveStatus']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('components/getDataList', this.dataQuery)
    },
  },
}
</script>
